import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import ProcessPage from './pages/ProcessPage'
import CoursesPage from './pages/CoursesPage'
import BlogPage from './pages/BlogPage'
import BlogPost from './pages/BlogPost'
import ContactsPage from './pages/ContactsPage'
import DatenschutzPage from './pages/DatenschutzPage'
import ImpressumPage from './pages/ImpressumPage'
import AGBPage from './pages/AGBPage'
import DatenschutzPageRU from './pages/DatenschutzPageRU'
import ImpressumPageRU from './pages/ImpressumPageRU'
import AGBPageRU from './pages/AGBPageRU'
import ProtectedAdminPanel from './components/admin/ProtectedAdminPanel'

function App() {
  return (
    <Router>
      <Routes>
        {/* Немецкий язык - корневые пути (без префикса) */}
        <Route path="/" element={<HomePage />} />
        <Route path="/process" element={<ProcessPage />} />
        <Route path="/courses" element={<CoursesPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/contact" element={<ContactsPage />} />
        <Route path="/datenschutz" element={<DatenschutzPage />} />
        <Route path="/impressum" element={<ImpressumPage />} />
        <Route path="/agb" element={<AGBPage />} />
        
        {/* Русский язык - с префиксом /ru */}
        <Route path="/ru" element={<HomePage />} />
        <Route path="/ru/process" element={<ProcessPage />} />
        <Route path="/ru/courses" element={<CoursesPage />} />
        <Route path="/ru/blog" element={<BlogPage />} />
        <Route path="/ru/blog/:slug" element={<BlogPost />} />
        <Route path="/ru/contact" element={<ContactsPage />} />
        <Route path="/ru/datenschutz" element={<DatenschutzPageRU />} />
        <Route path="/ru/impressum" element={<ImpressumPageRU />} />
        <Route path="/ru/agb" element={<AGBPageRU />} />
        
        {/* Админ панель */}
        <Route path="/admin/blog" element={<ProtectedAdminPanel />} />
      </Routes>
    </Router>
  )
}

export default App
